import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { EditFacModalService } from '../../service/edit-fac-modal.service';

export interface OfferedPodroductModel {
  offer_date: string;
  products: OfferedPodroductItemModel[];
}

interface OfferedPodroductItemModel {
  description: string;
  id: string;
  offer_time: string;
  original_offer_date: string;
  sku: string;
  url: string;
}

@Component({
  selector: 'app-modal-offered-product',
  templateUrl: './modal-offered-product.component.html',
  styleUrls: ['./modal-offered-product.component.scss']
})

export class ModalOfferedProductComponent implements OnInit {
  @Input() facdId = '';
  @Output() closeModal = new EventEmitter<void>();

  public list: OfferedPodroductModel[] = [];

  constructor(
    private facModalService: EditFacModalService
  ) { }

  @Input() featureProductSheet: boolean;
  public productUrl: string;
  ngOnInit(): void {
    this.facModalService.getOfferedProduct(this.facdId).subscribe((resp: OfferedPodroductModel[]) => {
      this.list = resp;
    });
  }

}
